import { useSyncExternalStore } from 'react';

import ConfirmDialog from './ConfirmDialog';
import { answerConfirm, getConfirms, removeConfirm, subscribeConfirms } from './confirmStore';

/** Shows what `confirm` asks, one question at a time. Mounted once, beside the Toaster. */
export function ConfirmHost() {
    const entries = useSyncExternalStore(subscribeConfirms, getConfirms, getConfirms);
    const current = entries[0];
    if (!current) return null;

    const { onConfirm, ...request } = current.request;
    return (
        <ConfirmDialog
            key={current.id}
            {...request}
            isOpen={current.open}
            onConfirm={async () => {
                await onConfirm?.();
                answerConfirm(current.id, true);
            }}
            onClose={() => answerConfirm(current.id, false)}
            onClosed={() => removeConfirm(current.id)}
        />
    );
}
